import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DashboardAuxiliaryService } from "@main/reporting.v3/dashboard/api/dashboard-auxiliary.service";
import { IDashboardView } from "@main/reporting.v3/dashboard/dashboard-models";

@Component({
    selector: "reporting-dashboard-pdf-layout-editor",
    templateUrl: "./dashboard-pdf-layout-editor.component.html",
    styleUrls: ["./dashboard-pdf-layout-editor.component.scss"]
})
export class ReportingDashboardPdfLayoutEditorComponent implements OnInit {
    private _headerHtmlCode: string;
    private _headerCssStyles: string;
    private _footerHtmlCode: string;
    private _footerCssStyles: string;

    private defaultHeaderHtmlCode: string;
    private defaultHeaderCssStyles: string;
    private defaultFooterHtmlCode: string;
    private defaultFooterCssStyles: string;

    protected dashboardCollapsed: boolean = true;

    @Input() dashboardView: IDashboardView;

    @Output() readonly onChange: EventEmitter<void> = new EventEmitter();

    @Output() readonly headerHtmlCodeChange: EventEmitter<string> = new EventEmitter();
    @Output() readonly headerCssStylesChange: EventEmitter<string> = new EventEmitter();
    @Output() readonly footerHtmlCodeChange: EventEmitter<string> = new EventEmitter();
    @Output() readonly footerCssStylesChange: EventEmitter<string> = new EventEmitter();

    constructor(private dashboardAuxiliaryService: DashboardAuxiliaryService) {
    }

    @Input() set headerHtmlCode(value: string) {
        if (this._headerHtmlCode === value) return;

        this._headerHtmlCode = value;
        this.headerHtmlCodeChange.emit(this._headerHtmlCode);
    }

    get headerHtmlCode(): string {
        return this._headerHtmlCode ?? this.defaultHeaderHtmlCode;
    }

    @Input() set headerCssStyles(value: string) {
        if (this._headerCssStyles === value) return;

        this._headerCssStyles = value;
        this.headerCssStylesChange.emit(this._headerCssStyles);
    }

    get headerCssStyles(): string {
        return this._headerCssStyles ?? this.defaultHeaderCssStyles;
    }

    @Input() set footerHtmlCode(value: string) {
        if (this._footerHtmlCode === value) return;

        this._footerHtmlCode = value;
        this.footerHtmlCodeChange.emit(this._footerHtmlCode);
    }

    get footerHtmlCode(): string {
        return this._footerHtmlCode ?? this.defaultFooterHtmlCode;
    }

    @Input() set footerCssStyles(value: string) {
        if (this._footerCssStyles === value) return;

        this._footerCssStyles = value;
        this.footerCssStylesChange.emit(this._footerCssStyles);
    }

    get footerCssStyles(): string {
        return this._footerCssStyles ?? this.defaultFooterCssStyles;
    }

    get dashboardHeaderClass(): string {
        return this.dashboardAuxiliaryService.dashboardHeaderClass;
    }

    get dashboardFooterClass(): string {
        return this.dashboardAuxiliaryService.dashboardFooterClass;
    }


    public ngOnInit(): void {
        this.defaultFooterHtmlCode = this.dashboardAuxiliaryService.getDashboardFooterDefaultHtml();
        this.defaultHeaderCssStyles = this.dashboardAuxiliaryService.getDashboardHeaderDefaultStyles();
        this.defaultHeaderHtmlCode = this.dashboardAuxiliaryService.getDashboardHeaderDefaultHtml();
        this.defaultFooterCssStyles = this.dashboardAuxiliaryService.getDashboardFooterDefaultStyles();

        this.headerHtmlCodeChange.subscribe(_ => this.onChange.emit());
        this.headerCssStylesChange.subscribe(_ => this.onChange.emit());
        this.footerHtmlCodeChange.subscribe(_ => this.onChange.emit());
        this.footerCssStylesChange.subscribe(_ => this.onChange.emit());
    }

    protected changeDashboardPreviewVisibility(event: MouseEvent): void {
        // If the event is not a pointer event, return.
        // This is being made to avoid collapsing on other mouse events like scrolling.
        if (!(event as PointerEvent)?.pointerId) return;
        this.dashboardCollapsed = !this.dashboardCollapsed;
    }
}